import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const StoreFranchiseIndicator = (_param)=> {
    var { className , label  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "label"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-franchise-indicator', className)
    }), label, /*#__PURE__*/ React.createElement(Icon, {
        name: "franchise",
        className: "store-franchise-indicator__icon"
    }));
};

export { StoreFranchiseIndicator as default };
//# sourceMappingURL=StoreFranchiseIndicator.js.map
